import { capitalize } from "@repo/shared/utils";
import type { Address } from "@repo/types";
export const AddressDisplay = ({
  address = {
    state: "",
    street: "",
    street2: "",
    city: "",
    country: "",
    type: "work",
    zip: "",
  },
}: {
  address?: Address;
}) => {
  return (
    <div>
      <div>
        <div>{capitalize(address.type)}</div>
        <div>{address.street}</div>
        <div>{address.street2}</div>
      </div>
      <div>
        <div>
          {address.city}
          {address.city ? ", " : null}
          {address.state} {address.zip}
        </div>
      </div>
    </div>
  );
};
